import { useState, useEffect } from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { useIdleTimer } from "react-idle-timer"

import useAuth from "../../../../hooks/useAuth"

const LogoutTimerModal = (): JSX.Element => {
  const [isIdle, setIsIdle] = useState(false)
  const [open, setOpen] = useState(false)
  const handleOnActive = () => setIsIdle(false)
  const handleOnIdle = () => setIsIdle(true)

  const timeout = 3600 * 1000
  const { logout } = useAuth()

  const handleClose = () => {
    setIsIdle(false)
  }

  const { getRemainingTime } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle
  })

  useEffect(() => {
    setInterval(() => {
      if (getRemainingTime() < 5000) setOpen(true)
      else setOpen(false)
    }, 1000)
  }, [getRemainingTime])

  useEffect(() => {
    if (isIdle) handleLogout()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIdle])

  const handleLogout = () => {
    try {
      logout()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
            Session will be logged out in{" "}
          {Math.floor(getRemainingTime() / 1000)} seconds
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default LogoutTimerModal
